import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ManageYieldService } from 'src/app/services/manage-yield.service';
import { PhameeService } from 'src/app/services/phamee.service';

@Component({
  selector: 'smart-manage-yield-list',
  templateUrl: './manage-yield-list.component.html',
  styleUrls: ['./manage-yield-list.component.scss','../../platform-color/platform-color.css']
})
export class ManageYieldListComponent implements OnInit {
  form: FormGroup;
  limit: number = 10;
  page: number = 1;
  total: any;

  allYield: any;
  authorize: any;
  displayedColumns: string[] = ['ลำดับ', 'พันธ์ุพืืช', 'Package', 'จำนวน / field', 'สถานะ'];
  farmList = [];
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  search: string = "";
  userRole: string = "";
  farm_id: string = "";

  loadFarm: boolean = false;
  canAccess: boolean = false;
  
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private PhameeService: PhameeService,
    private ManageYieldService: ManageYieldService,

    private cd: ChangeDetectorRef
  ) { 
    this.createForm();
    this.userRole = sessionStorage.getItem('role');
    this.route.queryParams
    .subscribe(params => {
      this.farm_id = params.farm_id;
    });
  }

  ngOnInit(): void {
    this.getFarm();
  }

  createForm(){
    this.form = this.formBuilder.group({
      farm: [""],
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async getFarm(){
    this.loadFarm = false;
    await this.PhameeService.getDropdownDashboard()
    .subscribe(success => {
 
      this.farmList = success.data.FarmList || [];

      if(this.userRole != 'worker' && this.userRole != 'viewer'){
        if(this.farmList.length > 0){

          if(this.farm_id){
            this.form.get('farm').setValue(this.farm_id);
            this.getYieldData(this.farm_id);
          }else{
            this.form.get('farm').setValue(this.farmList[0]._id);
            this.getYieldData(this.farmList[0]._id);
          }
        }
      }

      this.loadFarm = true;

      this.resetTemplate();
    });
  }

  async getYieldData(farm) {
    if(this.userRole != 'worker' && this.userRole != 'viewer'){
      this.canAccess = true;

      const org_id = sessionStorage.getItem('Org');
      const currentPackage = JSON.parse(sessionStorage.getItem('package'));
  
      this.spinner.show();
      this.page = 1
      this.dataSource.data = [];
  
      let filterManageYield = {
        org_id: org_id,
        package_id: currentPackage['package_id']
      }
      this.allYield = [];
      let plot = [];
      await this.ManageYieldService.getMainYieldTemplates(filterManageYield).subscribe(main=>{
       if(main.data){
        let data = main.data || [];
        
        this.PhameeService.getPlotDashboard(farm).subscribe(res=>{
          if(res.data){
            plot = res.data.plot.filter(plot => plot.status == 'on_crop') || [];
  
            for(let i = 0; i < data.length; i++){
              if(plot.find(plot=> plot.crop.breedType_id == data[i].breed_type_id)){

                if(data.filter(m=> m.breed_type_id == data[i].breed_type_id).length > 1){

                  let allMainFilter = data.filter(m=> 
                    m.breed_type_id == data[i].breed_type_id
                  );

                  let findMax = allMainFilter.reduce((prev, current) => 
                  (parseInt(prev.template_name.split(prev.package_name.replaceAll(/\s/g, ''))[1]) > parseInt(current.template_name.split(current.package_name.replaceAll(/\s/g, ''))[1]))
                   ? prev : current);

                  if(findMax == data[i]){
                    this.allYield.push(data[i]);
                  }
                }else{
                  this.allYield.push(data[i]);
                }
              }
            }
    
            this.ManageYieldService.getYieldTemplates({farm_id: farm, package_id: currentPackage['package_id']}).subscribe(resYield=>{
              for(let i = 0; i < this.allYield.length; i++){
              
                if(resYield.data && resYield.data.find(yie=> yie.breed_type_id == this.allYield[i].breed_type_id && this.allYield[i].package_id == yie.package_id)){
    
                  this.allYield[i] = resYield.data.find(
                    yie=> yie.breed_type_id == this.allYield[i].breed_type_id && 
                    this.allYield[i].package_id == yie.package_id
                    );
                }
              }
              this.resetTemplate();
            })
    
            this.dataSource.data = this.allYield;
            this.dataSource.sort = this.sort;
            this.spinner.hide();
          }else{
            this.spinner.hide();
          }
        })
       }else{
        this.spinner.hide();
       }
      });

      this.resetTemplate();
    }else{
      this.canAccess = false;
      this.resetTemplate();
    }
  }

  getPages(pageNo) {
    this.page = pageNo
  }

  resetPage(){
    this.page = 1
  }

  resetTemplate(){
    this.cd.detectChanges();
  }
}
